module.exports = __webpack_public_path__ + "media/12 Lantern Festival.8eb54bcb.mp3";